import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedTable from '../../Components/AdvancedTable'
import EllipsisModal from '../../Components/EllipsisModal'
import CreateInventory from '../../Containers/Ecommerce/CreateInventory'
import ManageInventoryImage from '../../Containers/Ecommerce/ManageInventoryImage'
import UpdateInventory from '../../Containers/Ecommerce/UpdateInventory'
import ViewInventoryImage from '../../Containers/Ecommerce/ViewInventoryImage'
import CategoryActions from '../../Redux/CategoryRedux'
import InventoryActions from '../../Redux/InventoryRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'
import BrandActions from '../../Redux/BrandRedux'
import SupplierActions from '../../Redux/SupplierRedux'
import FormatMoney from '../../Utils/FormatMoney'
// import ManageEcommerceProduct from '../../Containers/Ecommerce/ManageEcommerceProduct'
class ManageInventory extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.filterOrigin = [
      { label: 'ALL', value: '', restriction: 'PH' },
      { label: 'Passpod ID', value: 'ID', restriction: 'PH' },
      { label: 'Passpod PH', value: 'PH' }
    ]

    this.state = {
      showModal: null,
      detail: {},
      filter: {
        page: 1,
        title: '',
        category: '',
        brand: '',
        supplier: '',
        iso_code: ''
      },
      selectedCategory: { value: '', label: '' },
      selectedSupplier: { value: '', label: '' },
      selectedBrand: { value: '', label: '' }
    }
  }

  componentDidMount = () => {
    this._fetchInventory()
    this.props.getCategory()
    this.props.getSupplier()
    this.props.getBrand()
  }

  _fetchInventory = (event) => {
    if (event) { event.preventDefault() }
    let data = { ...this.state.filter }
    this.props.getInventory(data)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter }
    filter.page = page
    this.props.getInventory(filter)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId && !this.props.inventory.err) {
      this._fetchInventory()
    }
  }

  _filterChange = (data, field) => {
    let filter = { ...this.state.filter }

    filter[field] = data
    this.setState({ filter })
  }

  _selectItem = (item, action) => {
    if (action === 'update-inventory') {
      this.setState({
        selectedBrand: {
          value: !item.brand_id ? '' : item.brand_id,
          label: !item.brand ? '' : item.brand.name
        },
        selectedCategory: {
          value: !item.category_id ? '' : item.category_id,
          label: !item.category ? '' : item.category.name
        },
        selectedSupplier: {
          value: !item.supplier_detail ? '' : item.supplier_detail.id,
          label: !item.supplier_detail ? '' : item.supplier_detail.name
        }
      })
    }
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _deleteInventory = () => {
    this.props.deleteInventory(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  render () {
    const { inventory } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Inventory
              {
                (inventory.fetching || inventory.processing) &&
                <div className='badge badge-info ml-2'>{ inventory.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-inventory')}>
              <i className='fa fa-plus' /> Create Inventory
            </button>
          </div>
          <form className='form-inline' onSubmit={(event) => this._fetchInventory(event)}>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Search</label>
              <input style={{ width: '250px' }} type='text' placeholder='Product Title' className='form-control' value={this.state.filter.title} onChange={(event) => this._filterChange(event.target.value, 'title')} />
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Categories</label>
              <select value={this.state.filter.category} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'category')}>
                <option value=''> -- Select Category -- </option>
                {this.props.category.data.map((category, index) => (
                  <option value={category.id} key={index}> {category.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Brand</label>
              <select value={this.state.filter.brand} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'brand')}>
                <option value=''> -- Select Brand -- </option>
                {this.props.brand.data.map((brand, index) => (
                  <option value={brand.id} key={index}> {brand.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Supplier</label>
              <select value={this.state.filter.supplier} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'supplier')}>
                <option value=''> -- Select Supplier -- </option>
                {this.props.supplier.data.map((supplier, index) => (
                  <option value={supplier.id} key={index}> {supplier.name} </option>
                ))}
              </select>
            </div>
            <div className='form-group mr-2 mb-3'>
              <label className='control-label mr-2'>Origin</label>
              <select value={this.state.filter.iso_code} className='form-control' onChange={(event) => this._filterChange(event.target.value, 'iso_code')}>
                {this.filterOrigin.map((origin, index) => {
                  if (origin.restriction !== currentBranch()) {
                    return <option value={origin.value} key={index}> {origin.label} </option>
                  } else {
                    return false
                  }
                })}
              </select>
            </div>
            <div className='form-group mr-2 mb-2'>
              <button type='submit' className='btn btn-primary'>Apply Filter</button>
            </div>
          </form>
        </header>
        <section className='section' style={{ minWidth: '165%' }} >
          <div className='card'>
            {
              !(inventory.fetching || inventory.processing) && inventory.err &&
              <div className='alert alert-danger'>{inventory.err}</div>
            }
            <AdvancedTable
              colSpan={17}
              header={[
                { field: 'Name', className: 'text-left', style: { minWidth: '200px' } },
                { field: 'Master SKU' },
                { field: 'Category' },
                { field: 'Brand' },
                { field: 'Discount Type' },
                { field: 'Buy Price' },
                { field: 'Normal Price' },
                { field: 'Final Price' },
                { field: 'Weight' },
                { field: 'Supplier' },
                { field: 'Description' },
                { field: 'Status' },
                { field: 'Featured' },
                { field: 'Origin' },
                { field: 'Images', colSpan: '2' },
                { field: 'Edit Inventory' },
                { field: 'Delete Inventory' }
              ]}
              body={
                inventory.data.data &&
                inventory.data.data.length > 0 &&
                inventory.data.data.map((x) => ([
                  { field: x.name, className: 'text-left', style: { minWidth: '200px' } },
                  { field: x.sku_m },
                  { field: x.category.name },
                  { field: x.brand.name },
                  { field: x.discount_type },
                  { field: FormatMoney(x.buy_price) },
                  { field: FormatMoney(x.normal_price) },
                  { field: FormatMoney(x.final_price) },
                  { field: x.weight },
                  { field: x.supplier_detail ? x.supplier_detail.name : '-' },
                  { field: <EllipsisModal descriptor={'Inventory Description'} name={x.name} description={x.description} type='string' /> },
                  { field: x.status === 1 ? 'Active' : 'Inactive' },
                  { field: x.is_featured === 1 ? 'Yes' : 'No' },
                  { field: x.iso_code },
                  {
                    field: <button className='btn btn-primary ml-2' onClick={() => this._selectItem(x, 'view-inventory-image')}>
                      <i className='fa fa-eye' />
                    </button>
                  },
                  {
                    field: <button className='btn btn-primary ml-2' onClick={() => this._selectItem(x, 'manage-inventory-image')}>
                      <i className='fa fa-edit' />
                    </button>
                  },
                  {
                    field: <button className='btn btn-primary mr-2' onClick={() => this._selectItem(x, 'update-inventory')} >
                      <i className='fa fa-edit mr-2' />Edit
                    </button>
                  },
                  {
                    field: <button className='btn btn-danger' onClick={() => this._selectItem(x, 'delete-inventory')} >
                      <i className='fa fa-trash mr-2' />Delete
                    </button>
                  }
                ]))
              }
            />
          </div>
        </section>
        <section className='text-center'>
          {
            (inventory.data && inventory.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={inventory.data.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={inventory.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-inventory'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateInventory closeModal={() => this._toggleModal()} />
        </Modal>

        {/* TODO: futureproofing WIP. Necessary for removing manage ecommerce product page. */}
        {/* <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-product'} onClose={this._toggleModal}>
          <ManageEcommerceProduct detail={this.state.detail} />
        </Modal> */}

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-inventory'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateInventory detail={this.state.detail} selectedBrand={this.state.selectedBrand} selectedCategory={this.state.selectedCategory} selectedSupplier={this.state.selectedSupplier} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-inventory-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <ViewInventoryImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'manage-inventory-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <ManageInventoryImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal center open={this.state.showModal === 'delete-inventory'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Inventory</h3>
            </div>
            <div className='text-center'>
              <h6>
                Confirm deletion for "{this.state.detail.name}" category?
              </h6>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteInventory()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  inventory: state.inventory,
  category: state.category,
  supplier: state.supplier,
  brand: state.brand
})

const dispatchToProps = (dispatch) => ({
  getInventory: (filter) => dispatch(InventoryActions.getInventoryRequest(filter)),
  deleteInventory: (id) => dispatch(InventoryActions.deleteInventoryRequest(id)),
  getSupplier: (filter) => dispatch(SupplierActions.getSupplierRequest(filter)),
  getBrand: (filter) => dispatch(BrandActions.getBrandRequest(filter)),
  getCategory: (data) => dispatch(CategoryActions.getCategoryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ManageInventory)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageInventory.js